import styled, { css } from 'styled-components';
import Dialog from './Dialog';
import iconClose from '../../img/dlg-close.png';
import iconClose2X from '../../img/dlg-close@2x.png';
import { cssClearFix, cssFloatLeft, cssFloatRight } from '../common/CssCommon';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { closeDialog } from '../../store/modules/dialog';
import Button from '../common/Button';
import { useEffect, useRef, useState } from 'react';
import { setFileName, useDocInfoSliceSelector } from '../../store/modules/docInfo';
import { getExtension, getFileNameOnly } from '../../utils/FileControlUtil';
import { HEADER_CONTAINER_HEIGHT } from '../Header';
import Blanket from '../common/Blanket';

const TopPosition = `${HEADER_CONTAINER_HEIGHT}px`;

const DialogBody = styled.div`
  width: 302px;
  height: 127px;
  padding: 8px 12px 24px 12px;
  box-sizing: border-box;
`;

const TitleWrapper = styled.div`
  ${cssClearFix};
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 9px;
`;

const Title = styled.p`
  ${cssFloatLeft};
  flex: 1;
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

const CloseButton = styled.img`
  ${cssFloatRight};
  width: 24px;
  height: 24px;
  &:hover {
    cursor: pointer;
  }
`;

const InputFieldWrapper = styled.div`
  width: 100%;
  height: 22px;
  background-color: #ffffff;
  display: flex;
  box-sizing: border-box;
  padding: 3px 4px;
  border-radius: 2px;
  border: solid 1px #b1b6bb;
  background-color: #ffffff;
  align-items: center;
`;

const InputField = styled.input`
  flex: 1;
  border: none;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #2f3133;
  &:focus {
    outline: none;
  }
`;

const InputFieldExt = styled.div`
  margin-left: 6px;
  margin-right: 3px;
  width: 26px;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: right;
  color: #9f9f9f;
`;

const ExceptionMessageWrpper = styled.div`
  width: 100%;
  height: 14px;
  margin-top: 4px;
  margin-bottom: 5px;
`;

const ExceptionMessage = styled.p`
  margin: 0;
  font-size: 9px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #ff3333;
`;

const ConfirmBtnWrapper = styled.div`
  ${cssClearFix};
  width: 100%;
  height: 30px;
`;

function RenameDialog({ isShow }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const docInfoSlice = useDocInfoSliceSelector();
  const preFileName = getFileNameOnly(docInfoSlice.fileName);
  const fileExt = `.${getExtension(docInfoSlice.fileName)}`;
  const [inputText, setInputText] = useState(preFileName);
  const [errMessage, setErrorMessage] = useState('');
  const inputRef = useRef(undefined);

  useEffect(() => {
    if (inputRef.current) inputRef.current.select();
  }, [inputRef]);

  const onChangeInput = (e) => {
    setErrorMessage('');
    setInputText(e.target.value);
  };

  const onClickConfirm = () => {
    const replaceName = inputText.replace(/(^\s*)/g, "" ); //Remove front backspace
    if (replaceName === '') {
      setErrorMessage(t('RenameDialog.ExceptionEmpty'));
    } else if (/\\|\||\/|:|\*|\?|"|<|>|\t/g.test(replaceName)) {
      setErrorMessage(t('RenameDialog.ExceptionInput'));
    } else {
      dispatch(setFileName(`${replaceName}${fileExt}`));
      dispatch(closeDialog());
    }
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      onClickConfirm();
    }
  };

  return (
    <Blanket
      onClick={(e) => dispatch(closeDialog())}
      cssExt={css`
        background-color: transparent;
      `}>
      <Dialog
        isShow={isShow}
        isNoHeader
        isBlanketTransparent
        cssExt={css`
          left: 7px;
          top: ${TopPosition};
          transform: none;
        `}>
        <DialogBody onClick={(e) => e.stopPropagation()}>
          <TitleWrapper>
            <Title>{t('RenameDialog.Title')}</Title>
            <CloseButton
              src={iconClose}
              srcSet={iconClose2X}
              onClick={() => dispatch(closeDialog())}
            />
          </TitleWrapper>
          <InputFieldWrapper>
            <InputField
              value={inputText}
              onChange={onChangeInput}
              ref={inputRef}
              onKeyDown={onKeyDown}
            />
            <InputFieldExt>{fileExt}</InputFieldExt>
          </InputFieldWrapper>
          <ExceptionMessageWrpper>
            <ExceptionMessage>{errMessage}</ExceptionMessage>
          </ExceptionMessageWrpper>
          <ConfirmBtnWrapper>
            <Button
              primary
              cssExt={css`
                font-size: 13px;
                font-weight: 800;
                width: 74px;
                min-width: 74px;
                height: 30px;
                ${cssFloatRight}
                &:focus {
                  outline: none;
                }
              `}
              onClick={onClickConfirm}>
              {t('Common.Confirm')}
            </Button>
          </ConfirmBtnWrapper>
        </DialogBody>
      </Dialog>
    </Blanket>
  );
}

export default RenameDialog;
